import axios from 'axios';

var newsletterForm = document.getElementsByName("newsletter");

if (newsletterForm && newsletterForm.length > 0) {
    newsletterForm[0].onsubmit = function(event) {
        event.preventDefault();

        var formData = new FormData(newsletterForm[0]);

        newsletterForm[0].querySelector("[type='submit']").setAttribute('disabled', 'disabled');

        axios({
            method: "post",
            url: newsletterForm[0].getAttribute("action"),
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
        })
        .then(function (response) {
            if (response && response.status == 200) {
                newsletterForm[0].reset();
                setResponseMessage('success', response.data.message);
            } else {
                setResponseMessage('danger', response.data.message);
            }
            newsletterForm[0].querySelector("[type='submit']").removeAttribute("disabled");
        })
        .catch(function (response) {
            newsletterForm[0].querySelector("[type='submit']").removeAttribute("disabled");
        });
    }
}

function setResponseMessage(type, message) {
    var container = document.getElementById('newsletter-response');
    container.innerHTML = `<div class="alert alert-${type}" role="alert">${message}</div>`;
}
